
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/index';
import { STATE_DEFAULT } from './constants/state';
import { fromJS } from 'immutable';
import sidebarHistoryMiddleware from './middleware/sidebarHistoryMiddleware';
import runLatencyTest from './functions/runLatencyTest';
import { setIsConnectedFast } from './actions';


const getPreloadedState = () => {
    let preloadedState 

    if(window.pmkinoFrontVars) {
        preloadedState = window.pmkinoFrontVars
    } else {
        preloadedState = STATE_DEFAULT
    }

    return fromJS(preloadedState)
}


export const store = createStore(
    rootReducer,
    getPreloadedState(),
    composeWithDevTools(applyMiddleware(sidebarHistoryMiddleware))
);

runLatencyTest(isConnectedFast => store.dispatch(setIsConnectedFast(isConnectedFast)));